<template>
  			<div class="pers-warp">
				<div class="pers-cell" v-show="taskcount.students.length > 0" :class="backgroundColor(taskcount.name)" v-for="(taskcount, key) in studentData" :key="key">
					<!-- v-show="taskcount.students.length > 0" -->
					<div class="pers-cell-title" >
						<span :style="'border: 8px solid' + taskcount.color + ';'"></span>
						<span>{{ taskcount.name }}</span>
					</div>
					<div class="pers-cell-name">
						<span @click="goStudentStatistics(count)" v-for="(count, key1) in taskcount.students" :key="key1">{{ count.name }}</span>
					</div>
				</div>
			</div>
</template>

<script>
export default {
    data () {
        return {
            
        }
    },
	props:{
		studentData:{
			type:Array
		}
	},
    methods: {
        goStudentStatistics(val) {
            console.log(val)
			this.$emit('goStudentStatistics', val)
        },
		backgroundColor(type) {
			switch (type) {
				case '优++':
					return 'bg1';
					break;
				case '优+':
					return 'bg2';
					break;
				case '优':
					return 'bg3';
				case '良+':
					return 'bg4';
					break;
				case '良':
					return 'bg5';
					break;
				case '未批改':
					return 'bg6';
			}
		},
    }

}
</script>

<style lang="scss" scoped>
.pers-warp {
	display: flex;
	// flex-wrap: wrap;
	padding: 2% 3%;
	margin-bottom: 20px;
}

.pers-cell {
	// width: 380px;
	min-width: 190px;
	margin: 0 10px;
}

.pers-warp .pers-cell {
	margin-top: 10px;
}
.pers-warp .pers-cell .pers-cell-title {
	padding: 15px 15px 0 15px;
}
.pers-warp .pers-cell .pers-cell-title span {
	font-size: 14px;
	color: #787878;
	vertical-align: middle;	
}

.pers-warp .pers-cell .pers-cell-title span:first-child {
	display: inline-block;
	border-radius: 3px;
	margin: 6px;
	vertical-align: middle;
}

.pers-warp .pers-cell .pers-cell-name {
	/* border: 1px solid red; */
	padding-bottom: 18px;
	box-sizing: border-box;
	cursor: pointer;
}

.pers-warp .pers-cell .pers-cell-name span {
	display: inline-block;
	// width: 56px;
	// height: 30px;
	padding:9px 16px;
	font-size: 12px;
	color: #787878;
	// line-height: 30px;
	text-align: center;
	margin: 2% 0 0 4%;
	overflow: hidden;
	text-overflow: ellipsis;
	word-break: break-word;
	border-radius: 15px;
	background-color: #ffffff;
}
/* 统计名单背景色 */
.bg1 {
	background: #fff7f0;
}
.bg2 {
	background: #f0f2ff;
}
.bg3 {
	background: #ece8f7;
}
.bg4 {
	background: #f2fff0;
}
.bg5 {
	background: #eaf2f9;
}
.bg6 {
	background: #f5f5f5;
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/houseworkStatistic/components/StatisticsList.vue